import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub4_2/b851f2c11b9930f1b6e6f2983eb81cdf_water__c1_w280_h397.jpg'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'Elementary',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "Activity",
          subtitle: "Activity",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "꿈 창업 프로젝트", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("ul", { class: "line line4" }, [
                  _createElementVNode("li", null, "꿈·창업 프로젝트"),
                  _createElementVNode("li", null, [
                    _createElementVNode("dl", { class: "line2" }, [
                      _createElementVNode("dt", null, "제목"),
                      _createElementVNode("dd", null, "재능 발견으로 꿈을 창업하다!")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("figure", null, [
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-15af9999><dl data-v-15af9999><dt data-v-15af9999>목적</dt><dd data-v-15af9999> 학생이 자신의 재능, 관심, 꿈을 탐색, 실현하는 창업 계획 수립 활동을 통해<br data-v-15af9999> 자기 이해와 함께 미래에 나아갈 자신의 세상을 경험하는 기회를 제공한다. </dd></dl><dl data-v-15af9999><dt data-v-15af9999>목표</dt><dd data-v-15af9999> ① 개별적으로 관심 직업군을 선택하고, 함께 일하고 싶은 또래와 팀을 구성한다. <br data-v-15af9999> ② 팀 구성원들과 의논하여 창업 아이템을 선정하고 그에 따른 직무를 브레인스토밍, 분류한다.<br data-v-15af9999> ③ 사업을 위한 구체적인 계획을 수립하고, 과업 공고문을 토대로, 창업계획서를 작성한다. <br data-v-15af9999> ④ 팀 발표 및 심사에 따른 공간/지원금 결정으로, 공간 설계도 및 가구 배치도를 제작하여 최종산출물을 완성한다. </dd></dl><dl data-v-15af9999><dt data-v-15af9999>대상</dt><dd data-v-15af9999>초6</dd></dl><dl class=\"line2\" data-v-15af9999><dt data-v-15af9999>시간</dt><dd data-v-15af9999>3시간</dd></dl></li>", 1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-15af9999><ul class=\"line line4\" data-v-15af9999><li data-v-15af9999>팀 과제</li><li data-v-15af9999><dl class=\"line2\" data-v-15af9999><dt data-v-15af9999>재료</dt><dd data-v-15af9999> • 자료 1. 직업군 16종: (카드) 명칭 + 이미지 + 직무 목록 (1인1장)<br data-v-15af9999> • 자료 2. 과업 지시문: 복합창업공간지원사업 모집 공고문 + 공간 설계도<br data-v-15af9999> • 자료 3. 사업제안서 양식: 창업개요(w.1) + 사업자/구성원 소개(w.2) + 과업 내용 구성(w.3) + 공간/예산청구(w.4) </dd></dl></li></ul></div><div data-v-15af9999><ul class=\"line\" data-v-15af9999><li data-v-15af9999> 결과물<br data-v-15af9999> + 결과리포트<br data-v-15af9999> + 공간설계도 및 가구 배치도 </li><li data-v-15af9999><dl class=\"line2\" data-v-15af9999><dt data-v-15af9999>구성</dt><dd data-v-15af9999> • 모듈 1. [강의] (1) 21세기 직업군의 이해, (2) 프로그램 소개 및 안전 교육<br data-v-15af9999> • 모듈 2. 관심 직업군 선택 &gt;&gt; 팀 조직(1인~4인/팀)/직무 확인 &gt;&gt; 창업 아이템 논의/선정 &gt;&gt; 역할 분류<br data-v-15af9999> • 모듈 3. 창업 계획 및 창업계획서 작성<br data-v-15af9999> • 모듈 4. 발표 – 심사 &gt;&gt; 공간 위치 및 지원금 결정 &gt;&gt; 팀별 공간 설계도 및 가구 배치도 제작<br data-v-15af9999></dd></dl></li></ul></div><div data-v-15af9999><ul class=\"line\" data-v-15af9999><li data-v-15af9999>진행: 관리자</li><li data-v-15af9999><dl class=\"line2\" data-v-15af9999><dt data-v-15af9999>활용</dt><dd data-v-15af9999></dd></dl></li></ul></div>", 3)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Activity.Startup.Path}`
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("목록")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})